import BaseViewModel from '../../../base/BaseViewModel';

export default class CountryViewModel extends BaseViewModel {
    initialize(props) {
        super.initialize(props);
    }
}
